import { render, staticRenderFns } from "./preferred-educator-queue.vue?vue&type=template&id=92bfd710&scoped=true&"
import script from "./preferred-educator-queue.vue?vue&type=script&lang=js&"
export * from "./preferred-educator-queue.vue?vue&type=script&lang=js&"
import style0 from "./preferred-educator-queue.vue?vue&type=style&index=0&id=92bfd710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bfd710",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VBtn,VCard,VExpandTransition,VIcon,VSelect})
